import LineFunctionMean from './LineFunctionMean.js';
import LineFunctionPercentile from './LineFunctionPercentile.js';
import LineFunctionSd from './LineFunctionSd.js';
import LineFunctionRegression from './LineFunctionRegression.js';

export default class LineConfig {
  /**
   * @param {LineFunctionConfig} lineFunctionConfig
   * @param {string} lineStyle
   */
  constructor(lineFunctionConfig, lineStyle) {
    this._lineFunctionConfig = lineFunctionConfig;
    this._lineStyle = Object.assign({type:'', color:''}, lineStyle);
  }

  /** @return {LineFunctionConfig} */
  get functionConfig() {
    return this._lineFunctionConfig;
  }

  /** @return {{color: string, type: string} & string} */
  get lineStyle(){
    return this._lineStyle
  }

  /**
   *
   * @param {number[]|string[]} x
   * @param {number[]} y
   * @param xAxis
   * @param yAxis
   * @return {Promise<LineFunctionResult>}
   */
  async createLine(x, y, xAxis, yAxis) {
    return await this._lineFunctionConfig.getLineFunction().calculateLine(x, y, xAxis, yAxis);
  }

  /**
   * @param json
   * @return {LineConfig}
   */
  static parseServerJson(json) {
    return new LineConfig(
        new LineFunctionConfig(json.lineFunction.type, json.lineFunction.params, json.lineFunction.labelPattern),
        json.lineStyle
    );
  }
}

class LineFunctionConfig {
  static LINE_FUNCTIONS = {
    'mean': {func: LineFunctionMean, params: []},
    'sd': {func: LineFunctionSd, params: ['numOfSd']},
    'percentile': {func: LineFunctionPercentile, params: ['percentile']},
    'regression': {func: LineFunctionRegression, params: []},
  };

  constructor(functionType, functionParams, labelPattern) {
    this._functionType = functionType;
    this._functionParams = functionParams;
    this._labelPattern = labelPattern;
  }

  get type(){
    return this._functionType;
  }

  get params() {
    return this._functionParams
  }

  set params(funParams) {
    this._functionParams = funParams;
  }

  get labelPattern() {
    return this._labelPattern
  }

  set labelPattern(pattern) {
    this._labelPattern = pattern;
  }

  getLineFunction() {
    const lineFunction = LineFunctionConfig.LINE_FUNCTIONS[this._functionType].func;
    return new lineFunction(this._labelPattern, this._functionParams);
  }
}